import * as React from "react";
import { connect } from "common/connect";
import StoreKeys from "common/storeKeys";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { Colors } from "styles/Colors";
import SvgViewer from "bracket-system/svg-viewer";
import {
    BountyModel,
    bountyModelContext,
    fillBountyFreeformParts,
} from "common/helpers/bountyHelper";
import UserManager from "common/userManager";
import BountyBracket from "./BountyBracket";
import BountyBracketEditor from "./BountyBracketEditor";

const useStyles = makeStyles((theme) => {
    return {
        bracketWrapper: {
            border: `2px solid ${Colors.panel}`,
            borderRadius: theme.shape.borderRadius,
            overflow: "hidden",
            userSelect: "none",
        },
    };
});

const propKeys = {
    eventData: StoreKeys.EVENT.EVENTDATA,
    format: StoreKeys.EVENT.FORMAT,
    userBracketPicks: StoreKeys.EVENT.USER.BRACKET_PICKS,
    officialBracketPicks: StoreKeys.EVENT.OFFICIAL.BRACKET_PICKS,
    isEditing: StoreKeys.EVENT.IS_EDITING,
    stageIndex: StoreKeys.EVENT.STAGE_INDEX,
    showOfficial: StoreKeys.EVENT.SHOW_OFFICIAL,
};

function BountyBracketRendererC({
    eventData,
    format,
    userBracketPicks,
    officialBracketPicks,
    isEditing,
    width,
    stageIndex,
    showOfficial,
}) {
    const ref = React.useRef();
    const styles = useStyles();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
    const bracketWidth = !isSmall
        ? window.innerWidth - 382
        : window.innerWidth - 24;

    let baseUIHeight = isSmall ? 345 : 331;
    const bottomNavHeight = 56;
    const loggedIn = UserManager.isLoggedIn();
    const otherUIHeight =
        (isSmall ? baseUIHeight + bottomNavHeight : baseUIHeight) +
        (loggedIn ? 39 : 0);
    const renderHeight = Math.max(window.innerHeight - otherUIHeight, 200);

    const currentStage = format.stages[stageIndex];
    const currentEventStage = eventData.eventStages[stageIndex];

    const model = new BountyModel(
        bountyModelContext(
            eventData,
            currentStage,
            currentEventStage,
            officialBracketPicks,
            userBracketPicks
        )
    );

    const parts = fillBountyFreeformParts(model, eventData.teams, {
        official: showOfficial,
        withCues: !showOfficial,
    });

    // memoized so re-renders don't remount and reset the viewer
    const svgWrapper = React.useCallback(
        ({ children, ...props }) => (
            <SvgViewer
                width={ref.current?.offsetWidth ?? bracketWidth ?? width}
                height={renderHeight}
                {...props}
            >
                {children}
            </SvgViewer>
        ),
        [bracketWidth, renderHeight, width]
    );

    return (
        <>
            {isEditing && <BountyBracketEditor />}
            {!isEditing && (
                <div className={styles.bracketWrapper} ref={ref}>
                    <BountyBracket
                        parts={parts}
                        svgWrapper={svgWrapper}
                        hideSeriesScore={!model.useSeriesScore}
                    />
                </div>
            )}
        </>
    );
}

export default function BountyBracketRenderer(props) {
    return connect(<BountyBracketRendererC />, propKeys, props);
}
